


export class PublicationsLastModel {

    constructor() {

        this.state = {};
        this.listeners = [];
    }

    subscribe(listener) {
        this.listeners.push(listener);
        listener(this.state);
    }

    setState(newState) {
        this.state = { ...this.state, ...newState };
        this.listeners.forEach(listener => listener(this.state));
    }
}